import MenuInfo from 'data/menu';
import { Link, Outlet } from 'react-router-dom';

export default function MonitoringReportDataroomLayout() {
    const report_dataroom = MenuInfo.CMMS_REPORT_DATAROOM;
    return (
        <>
            <div className="mrosetup_sub">
                <ul>
                    {
                        report_dataroom.children.map(child => {
                            return (
                                <li key={child.id}>
                                    <Link to={child.fullpath}>
                                        {
                                            child.isActive
                                            ? (<b>{child.name}</b>) 
                                            : child.name
                                        }
                                    </Link>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>

            <div className="main_container">
                <Outlet/>
            </div>
        </>
    );
}